import { render, staticRenderFns } from "./Rekomendasi.vue?vue&type=template&id=67668a4a&"
import script from "./Rekomendasi.vue?vue&type=script&lang=js&"
export * from "./Rekomendasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports